import { useLocation } from "wouter";
import { X, FileText, Wrench, Building2, Megaphone, Briefcase, FolderKanban, ReceiptText, Package, ChevronRight } from "lucide-react";
import { postTypes } from "../data/mock";

const icons: Record<string, any> = { FileText, Wrench, Building2, Megaphone, Briefcase, FolderKanban, ReceiptText, Package };

export function PostMenu({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [, navigate] = useLocation();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-start sm:items-center justify-center p-4 pb-28 sm:pb-4 bg-navy/50 backdrop-blur-sm overflow-y-auto" onClick={onClose}>
      <div className="card w-full max-w-2xl p-5 sm:p-6 mt-16 sm:mt-0 mb-[max(1rem,env(safe-area-inset-bottom))]" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-extrabold text-navy">What would you like to post?</h3>
          <button onClick={onClose} className="btn-ghost h-8 w-8 p-0"><X className="w-5 h-5" /></button>
        </div>
        <div className="grid sm:grid-cols-2 gap-2.5">
          {postTypes.map((t) => {
            const Icon = icons[t.icon];
            return (
              <button
                key={t.key}
                onClick={() => { onClose(); navigate(`/post/${t.key}`); }}
                className="flex items-center gap-3 p-3 rounded-lg border border-line hover:border-navy-500 hover:bg-navy-50 text-left transition-colors group"
              >
                <div className="w-10 h-10 rounded-lg bg-navy-50 text-navy grid place-items-center shrink-0"><Icon className="w-5 h-5" /></div>
                <div className="min-w-0 flex-1">
                  <div className="font-semibold text-navy text-sm">{t.title}</div>
                  <div className="text-xs text-mut">{t.sub}</div>
                </div>
                <ChevronRight className="w-4 h-4 text-mut group-hover:text-navy" />
              </button>
            );
          })}
        </div>
        <p className="text-xs text-mut mt-4 text-center">One account, multiple activities — you can post any of these anytime.</p>
      </div>
    </div>
  );
}
